<div class="card coffee-card">
  <div class="card-header">
    <h2 class="h4">Coffee Club</h2>
  </div>
  <div class="card-body">
    <div class="blurb">
      This could be a blurb about the Coffee Club and how often they meet
      What Time in the morning, that might be useful.
    </div>
    <div class="coffee-time-display">
      <i class="fas fa-coffee fa-fw"></i>
      <span>{{nextMeeting | amDateFormat:'DD MMM YYYY (dddd)'}}</span>
      <i class="fas fa-coffee fa-fw"></i>
    </div>
  </div>
</div>
